var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSpinDistribution = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1788 0.231206C12.4072 0.0412156 12.7082 -0.037375 13.0004 0.016731C18.1262 0.96611 22.0001 5.48924 22.0001 10.9169C22.0001 13.2461 21.2858 15.4108 20.0651 17.1965C19.8968 17.4428 19.6273 17.6011 19.3303 17.6281C19.0332 17.6552 18.7396 17.5482 18.5295 17.3364L13.8032 12.5708C13.5533 12.3188 13.4557 11.9533 13.5467 11.6103C13.605 11.3903 13.6364 11.1581 13.6364 10.9169C13.6364 9.92707 13.1043 9.06533 12.3144 8.60461C12.0072 8.42541 11.8182 8.09649 11.8182 7.74081V1.00001C11.8182 0.70291 11.9503 0.421195 12.1788 0.231206ZM10.1818 1.00001C10.1818 0.70291 10.0497 0.421195 9.8213 0.231206C9.59289 0.0412156 9.29183 -0.037375 8.9997 0.016731C3.87381 0.96611 0 5.48924 0 10.9169C0 17.0301 4.91708 22 11 22C13.3156 22 15.4663 21.278 17.2389 20.0461C17.4816 19.8774 17.6372 19.6101 17.6641 19.3159C17.691 19.0216 17.5863 18.7305 17.3783 18.5207L12.6519 13.7551C12.3989 13.5 12.0285 13.4002 11.6815 13.4938C11.4652 13.5521 11.237 13.5835 11 13.5835C9.55177 13.5835 8.36364 12.3974 8.36364 10.9169C8.36364 9.92707 8.89577 9.06533 9.68565 8.60461C9.99289 8.42541 10.1818 8.09649 10.1818 7.74081V1.00001Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSpinDistribution);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_spin_distribution.910bdc45fa742699394604253101943f.svg";